// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Layout from "../layout/Layout.js";

import './PostPage.scss'
;

function PostPage(Props) {
  var pageContext = Props.pageContext;
  return React.createElement(Layout.make, {
              children: React.createElement("article", undefined, React.createElement("h1", {
                        className: "title"
                      }, pageContext.title), React.createElement("div", {
                        className: "markdown-body",
                        dangerouslySetInnerHTML: {
                          __html: pageContext.html
                        }
                      }))
            });
}

var make = PostPage;

var $$default = PostPage;

export {
  make ,
  $$default ,
  $$default as default,
  
}
/*  Not a pure module */
